import {Experiments, Store} from 'client/common/types';

export function getExperiments(state: Store): Experiments {
    return state.user.experiments;
}
